<template>
  <q-list class="no-border">
    <q-item-label header class="q-pb-none">
      Mentions
    </q-item-label>

    <q-item class="no-padding">
      <q-item-section class="q-pt-sm">
        <div
          class="altmetric-embed"
          data-badge-type="medium-donut"
          data-badge-details="right"
          data-link-target="_blank"
          :data-doi="article.doi"
        ></div>
        <script
          type="application/javascript"
          src="https://d1bxh8uas1mnw7.cloudfront.net/assets/embed.js"
          defer
        ></script>
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script>
export default {
  props: {
    article: Object
  }
}
</script>

<style lang="stylus" scoped>
>>> .altmetric-see-more-details {
  padding 0 !important
  margin 0
}
</style>
